import { IconButton } from '@mui/material';
import React, { FC, useState } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { ratingTypes } from 'shared/constants/ratingTypes';
import { ShopRelatedProductsModal } from 'modules/shop/components/ShopRelatedProductsModal';
import { shopProductsCategories } from 'modules/shop/shared/constants/shopProductsCategories';
import { ShopProductLines } from 'modules/shop/shared/constants/shopProductLines';
import { PortfolioEntity } from '../../types';

type ScoreLockProps = {
  entity: PortfolioEntity;
  module: ratingTypes;
  customHandler?: () => void;
};

export const ScoreLock: FC<ScoreLockProps> = ({ entity, module, customHandler }) => {
  const [open, setOpen] = useState(false);

  const data = {
    category: {
      [ratingTypes.CREDIT_RATING]: shopProductsCategories.creditAnalysis,
      [ratingTypes.CREDIT_REVIEW]: shopProductsCategories.creditAnalysis,
      [ratingTypes.ESG_IMPACT]: shopProductsCategories.esgAnalysis,
      [ratingTypes.SENTIMENT]: shopProductsCategories.esgAnalysis,
    }[module],
    productLine: {
      [ratingTypes.CREDIT_RATING]: ShopProductLines.Rating,
      [ratingTypes.CREDIT_REVIEW]: ShopProductLines.Rating,
      [ratingTypes.ESG_IMPACT]:
        entity.meta.esgCustomScore || entity.meta.esgCustomScore === null
          ? ShopProductLines.Tools
          : ShopProductLines.Review,
      [ratingTypes.SENTIMENT]:
        entity.meta.esgCustomScore || entity.meta.esgCustomScore === null
          ? ShopProductLines.Tools
          : ShopProductLines.Review,
    }[module],
    countriesAndIndustries: [
      {
        country: entity.countryCode,
        industries: [entity.industry],
      },
    ],
  };

  const toggle = () => setOpen((prev) => !prev);

  return (
    <>
      <IconButton color="inherit" onClick={customHandler || toggle} size="large">
        <LockIcon />
      </IconButton>
      {open && (
        <ShopRelatedProductsModal
          data={data}
          open={open}
          onClose={toggle}
          onConfirm={toggle}
          module={module}
        />
      )}
    </>
  );
};
